import isEmpty from '#src/client/common/utils/isEmpty.js';
import emailError from '#src/client/common/validators/emailError.js';

export const genDefaultData = () => {
    return {
        urlApiLogin: '',
        username: '',
        password: '',
        e: {
            username: '',
            password: '',
            all: '',
        },
    };
};

export const transformServerData = (originalData, serverData) => {
    return {
        ...originalData,
        ...serverData,
    };
};

export const validation = (state) => {
    const usernameError = isEmpty(state.username) ? 'Required' : emailError(state.username);
    const passwordError = isEmpty(state.password) ? 'Required' : '';

    const errors = {
        username: usernameError,
        password: passwordError,
    };

    state.e.username = errors.username;
    state.e.password = errors.password;
    state.e.all = Object.values(errors).some(Boolean);
};

export const transformClientData = (state) => {
    return {
        username: state.username,
        password: state.password,
        next: state.next,
    };
};

export default {
    genDefaultData,
    transformServerData,
    validation,
    transformClientData,
};
